var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChrono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33.6293441px",
    height: "39.4625813px",
    viewBox: "0 0 33.6293441 39.4625813",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CCAC88BA-6E57-4FC7-8747-589F882B4518") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "maquette-V0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5a_1024_espace-compte_darty-max_default",
    transform: "translate(-620.3223, -1564.7538)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mes-services-darty-max",
    transform: "translate(274, 1315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OptimisationUI/Bloc-privil\\xE8ge-Copy-2",
    transform: "translate(251, 217.4367)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "darty/Color/Services/SAV",
    transform: "translate(95.3223, 32.3172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "VF",
    transform: "translate(16.8147, 19.7313) scale(1, -1) translate(-16.8147, -19.7313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8144279,0 C26.1006489,0 33.6293441,7.52869525 33.6293441,16.8149162 C33.6293441,25.1542345 27.5590262,32.0749009 19.5967076,33.4007196 L19.596,34.028 L22.0797289,34.0283645 L22.0797289,39.4625813 L11.5047859,39.4625813 L11.5047859,34.0283645 L13.989,34.028 L13.9892747,33.393521 C6.04813778,32.0500341 0,25.1392551 0,16.8149162 C0,7.52869525 7.52820691,0 16.8144279,0 Z",
    id: "Combined-Shape",
    fill: "#006AF5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g142",
    transform: "translate(4.6644, 4.6528)",
    fill: "#FFDB00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3128462,12.1556906 C24.3128462,5.44251856 18.8698393,0 12.1561789,0 C5.44349523,0 0,5.44251856 0,12.1556906 C0,18.869351 5.44349523,24.3123579 12.1561789,24.3123579 C18.8698393,24.3123579 24.3128462,18.869351 24.3128462,12.1556906",
    id: "path144"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g146",
    transform: "translate(4.6645, 13.3699)",
    fill: "#E21212"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1210187,3.36415526 L12.1210187,15.5930965 C5.42493841,15.573563 0,10.1403228 0,3.43838252 C0,2.24342129 0.179219768,1.09143373 0.500545672,0 L12.1210187,3.36415526 Z",
    id: "path148"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrono);
export default __webpack_public_path__ + "static/media/chrono.4b8c678b87bba8c03d5a2feade366e25.svg";
export { ForwardRef as ReactComponent };